var angular = require('angular');
require('ng-dialog');
require('../cropit');

 angular
  .module("app.directives")
  .directive('photoUpload', function(ngDialog){
    return {
      restrict: 'E',
      scope: {
        cropper: '@?',
      },
      require: 'ngModel',
      template: require('./index.pug'),
      transclude: true,
      replace: true,
      link: function (scope, element, attrs, ngModel) {

        if (attrs.change) {
          ngModel.$viewChangeListeners.push(function() {
            var applying = scope.$parent.$eval(attrs.change);
            scope.changing = applying.then ? applying.finally(function(){
              scope.changing = null;
            }) : null;
          })
        }

        scope.$watch(function(){
          return ngModel.$viewValue;
        }, function(val){
          scope.model = val;
        })

        scope.open = function($event){
          $event.preventDefault();
          scope.openUpload();
        }

        scope.openUpload = function () {
          return ngDialog.open({
            template: require("./dialogs/upload.pug")(),
            controller: require("./dialogs/upload"),
            plain: true,
            disableAnimation: true,
            resolve: {
              file: function(){ return scope.model },
            }
          }).closePromise.then(function (obj) {

            if (obj.value && obj.value.action == 'removed') {
              ngModel.$setViewValue({});
              return;
            }

            if (obj.value && obj.value.action == 'uploaded') {
              if (!scope.cropper) {
                ngModel.$setViewValue(obj.value.file)
                return;
              }

              return scope.openCrop(obj.value.file);
            }

          });
        }

        scope.openCrop = function (file) {
          return ngDialog.open({
            template: require("./dialogs/crop.pug")(),
            controller: require("./dialogs/crop"),
            plain: true,
            disableAnimation: true,
            resolve: {
              file: function () { return file },
              options: function () { return { size: scope.cropper } }
            }
          }).closePromise.then(function (obj) {
            if (!obj.value.action || obj.value.action == 'back') {
              return scope.openUpload();
            }

            if (obj.value.action == 'save') {
              ngModel.$setViewValue(obj.value.file)

            }

          });
        }


      }
    }


  })
  .directive('imgDocSrc', function(){
    return {
      restrict: 'A',
      scope: {
        obj: '=imgDocSrc'
      },
      link: function(scope, element, attrs){
        scope.$watch('obj', function(obj){
          if (Array.isArray(obj)) {
            obj = obj[0];
          }
          var src = (obj && obj.blobId && obj.fileName) && encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent(obj.blobId.replace(/-/g, '')) + "/" + obj.fileName);
          element.attr('src', src || 'https://placehold.co/255x200?text=no+image');
        })
      }
    }
  })

  .filter('imgDocSrc', function(){
    return function(obj){
      return (obj && obj.blobId && obj.fileName) ? encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent(obj.blobId.replace(/-/g, '')) + "/" + obj.fileName) : null;
    }
  })
  .filter('imgIDSrc', function(){
    return function(id, filename){
      return id && filename ? encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent(id.replace(/-/g, '')) + "/" + filename) : null;
    }
  })
